import { Api, ConfigHelper, createApiService } from 'relapp-api';

export default {
    ...createApiService('nameservers', 'domain.nameservers'),

    /**
     * Reset the nameservers for a domain.
     *
     * @param {string} domain
     *
     * @return {Promise}
     */
    reset(domain) {
        const url = ConfigHelper.apiUrl('domain.nameservers.reset', [
            {
                key: '{domain}',
                value: domain
            }
        ]);

        return Api.post(url);
    }
};
